/**
 * @module experience/billing-and-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const SAVED_PAYMENT_CARD_CONSTANTS = {
  SAVED_PAYMENT_MODULE: 'savePaymentModule',
  SAVED_PAYMENT_CARD_COMPONENT: 'savedPaymentCardComponent',
  SUPPORTED: 'Supported',
  ROUTE_STORED_PAYMENT: '/my-profile/stored-payment-methods',
  MANAGE_PROFILE_MODULE: 'ManageProfileModule',
  PAYMENT_RESPONSE_STATUS_VALID: 'VALID',
  PAYMENT_RESPONSE_STATUS_BLOCKED: 'BLOCKED',
  TRUE: 'true',
  ANON: 'ANON',
};
